/* eslint-disable no-param-reassign */
import type { PropertyIdentificationConfig, TaxIdTypeDetail } from '@common/entities';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface PropertyLocale {
  localeCode: string;
  localeName: string;
  isDefault: boolean;
}

export interface PropertyLocation {
  timeZoneId: number;
  countryCode: string;
  localeCode: string;
  drivingDirections: string;
}

export interface PropertyItem {
  propertyId: number;
  propertyName: string;
  languages?: PropertyLocale[];
  countryCode?: string;
  location?: PropertyLocation;
  taxIdTypes?: TaxIdTypeDetail[];
  identificationConfig?: PropertyIdentificationConfig;
}

export interface PropertiesState {
  properties: PropertyItem[];
}

const initialState: PropertiesState = {
  properties: [],
};

const propertiesSlice = createSlice({
  name: 'properties',
  initialState,
  reducers: {
    setProperties(state, action: PayloadAction<PropertyItem[]>) {
      state.properties = action.payload;
    },
  },
});

export const { setProperties } = propertiesSlice.actions;
export default propertiesSlice.reducer;
